import _get from 'lodash.get';
import _ from 'underscore';
import authCheckUtil from '../utils/auth_check_util';
import cookieUtil from 'js-cookie';
import featureFlags from '../../../../../feature_flags';

class Config {
    constructor() {
        const referrer = document.referrer;
        // todo add an 'is published' to prevent what happened today in fb
        const host = window.location.hostname;
        let port = window.location.port;
        if (port !== '') {
            port = ':' + port;
        }
        const currentSiteUrl = host + port;
        let clientEnv = 'production';
        let stagingHost;
        const sites = [
            'fastcompany',
            'fastcodesign',
            'fastcoexist',
            'fastcocreate',
            'fastcolabs'
        ];
        let siteUrls = sites.map((url) => {
            return `${url}.com`;
        });

        if (port === ':8880') {
            clientEnv = 'development';
            siteUrls = sites.map((url) => {
                return `${url}.local:8880`;
            });
        }

        if (/beta/.test(window.location.host.split('.')[0])) {
            clientEnv = 'staging';
            stagingHost = window.location.host.split('.')[0];
            siteUrls = sites.map((url) => {
                return `${stagingHost}.${url}.com`;
            });
        }

        const initialPageLoad = true;

        this.config = _.extend({
            referrer,
            featureFlags,
            initialPageLoad,
            clientEnv,
            currentSiteUrl,
            stagingHost,
            siteUrls
        }, window.bootstrap_config, {
            bootstrap_id: window.bootstrap_id,
            bootstrap_kind: window.bootstrap_kind,
            bootstrap_type: window.bootstrap_type,
            bootstrap_obj: window.bootstrap_obj
        });
    }

    get(property) {
        const prop = _get(this.config, property);
        if (prop === undefined && _get(window, 'bootstrap_config.env') === 'development') {
            /* eslint-disable no-console */
            console.warn(`js/config/index.js: Property ${property} is undefined.`);
        }
        return prop;
    }

    authCheck() {
        if (cookieUtil('fc_auth')) {
            return authCheckUtil().then((user) => {
                const userData = _get(user, 'user');
                if (userData) {
                    this.config.loggedIn = true;
                    this.config.userData = userData;
                }
            });
        }
    }

    setinitialPageLoad() {
        this.config.initialPageLoad = false;
    }
}

export default new Config();
